export const OPEN_DIALOG_SUCCESS = 'OPEN_DIALOG_SUCCESS'
export const CLOSE_DIALOG_SUCCESS = 'CLOSE_DIALOG_SUCCESS'
export const SET_DIALOG_LOADING = 'SET_DIALOG_LOADING'